module.exports = __webpack_public_path__ + "static/img/celoscope-detail-6.357cc7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-6.jpg
// module id = HQ7C
// module chunks = 52